@if (data$ | async; as data) {
  <div class="mb-3 rounded-sm border border-blue-300 bg-blue-100 p-4">
    Zmiana adresu rozliczeniowego będzie miała zastosowanie od przyszłej edycji.
  </div>

  <app-alerts />

  <app-admin-subscription-billing-address-form
    [data]="data"
    [pending]="pending()"
    (submitClickEvent)="handleSubmitClickEvent($event)" />
} @else {
  <app-spinner-filled />
}
